import { useSelector } from "react-redux";
export default (title) => {
  const userData = useSelector((state) => state.app.userData.userData);
  const colCount = title?.length;
  const gridStyle = {
    gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
  };

  return { colCount, gridStyle, userData };
};
